(() => {
  const bars = document.querySelectorAll('[data-ff-hdr-cd]');
  if (!bars.length) return;

  const pad2 = (n) => String(Math.max(0, n)).padStart(2, '0');

  bars.forEach((bar) => {
    const endStr = bar.getAttribute('data-end') || '';
    const end = new Date(endStr);

    if (Number.isNaN(end.getTime())) return;

    const elDays = bar.querySelector('[data-ff-days]');
    const elHours = bar.querySelector('[data-ff-hours]');
    const elMins = bar.querySelector('[data-ff-mins]');
    const elSecs = bar.querySelector('[data-ff-secs]');

    const tick = () => {
      const now = new Date();
      let diff = end.getTime() - now.getTime();
      if (diff < 0) diff = 0;

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;

      if (elDays) elDays.textContent = pad2(days);
      if (elHours) elHours.textContent = pad2(hours);
      if (elMins) elMins.textContent = pad2(mins);
      if (elSecs) elSecs.textContent = pad2(secs);
    };

    tick();
    const id = window.setInterval(tick, 1000);

    bar.addEventListener('shopify:section:unload', () => window.clearInterval(id));
  });
})();